import type Phaser from 'phaser';
import type { AudioManager } from './AudioManager';
import { COMBAT_DEFAULTS } from '@shared/data/sounds';

/**
 * Sonidos de UI (hover/click) reutilizables. `attachUiSound` engancha los eventos `pointerover`/
 * `pointerup` de un GameObject interactivo para reproducir el SFX de interfaz correspondiente.
 *
 * El AudioManager se registra una vez (desde GameScene) vía `setUiAudioManager`, así los helpers
 * de UI no necesitan una referencia a la escena. Es no-op hasta que hay manager (login, editores).
 * Ver docs/SOUND_AND_MUSIC.md.
 */

const UI_HOVER_SOUND = 'sfx_ui_hover';
const UI_CLICK_SOUND = 'sfx_ui_click';

let manager: AudioManager | null = null;

export function setUiAudioManager(m: AudioManager | null): void {
  manager = m;
}

export function playUiHover(): void {
  manager?.play(UI_HOVER_SOUND);
}

export function playUiClick(): void {
  manager?.play(UI_CLICK_SOUND);
}

/**
 * Engancha hover + click a un GameObject ya interactivo (`setInteractive`). Idempotente por objeto
 * (no re-registra). `opts` permite desactivar hover o click puntualmente.
 */
export function attachUiSound(
  obj: Phaser.GameObjects.GameObject,
  opts: { hover?: boolean; click?: boolean } = {}
): void {
  const anyObj = obj as unknown as { __aureumUiSound?: boolean };
  if (anyObj.__aureumUiSound) return;
  anyObj.__aureumUiSound = true;

  if (opts.hover !== false) {
    obj.on('pointerover', () => playUiHover());
  }
  if (opts.click !== false) {
    obj.on('pointerup', () => playUiClick());
  }
}

/** Referencia al default de combate/loot para consumidores que no importan el registro entero. */
export const AUDIO_DEFAULTS = COMBAT_DEFAULTS;
